import { render, staticRenderFns } from "./ListPaciente.vue?vue&type=template&id=1acd9d6e&scoped=true&"
import script from "./ListPaciente.vue?vue&type=script&lang=js&"
export * from "./ListPaciente.vue?vue&type=script&lang=js&"
import style0 from "./ListPaciente.vue?vue&type=style&index=0&id=1acd9d6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acd9d6e",
  null
  
)

export default component.exports